import { ChecklightSessionStatus } from '@thesavingsgroup/enums/ChecklightSessionStatus';

export const QUEUED_TASK_STATUSES: string[] = [
  ChecklightSessionStatus.QUEUED_FOR_SUBMISSION,
];
